import axios from '@axios'

const PREFIX = 'portal'

export default {

  getCobrancas(empresaId, filtros) {
    return axios.post(`${PREFIX}/${empresaId}`, filtros)
  },
  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historicos`)
  },
  getURLDocumento(id) {
    return axios.get(`${PREFIX}/${id}/url`)
  },
  naoSeAplica(id, aplicar, justificativa) {
    return axios.get(`${PREFIX}/${id}/nao-se-aplica?aplicar=${aplicar}&justificativa=${justificativa}`)
  },

  resetEnvioDocumento(id) {
    return axios.get(`${PREFIX}/${id}/documento-reset`)
  },

  getDadosUpload(id, file) {
    return axios.post(`${PREFIX}/${id}/dados-upload`, file)
  },

  atualizaDocumentoStatus(id, file, observacao) {
    return axios.post(`${PREFIX}/${id}/alterar-status?observacao=${observacao}`, file)
  },

  limparEnvioDocumentoNuvem(id, file) {
    return axios.post(`${PREFIX}/${id}/remover-arquivo`, file)
  },

  getDadosParaSalvarStorage(empresaId, nomeArquivo) {
    return axios.post(`${PREFIX}/${empresaId}/dados-upload-lote?nomeArquivo=${nomeArquivo}`)
  },

  salvarArquivoCarregadoEmLote(data) {
    return axios.post(`${PREFIX}/arquivo-lote`, data)
  },

  getArquivosCarregadosEmLoteByEmpresa(empresaId) {
    return axios.get(`${PREFIX}/${empresaId}/arquivo-lote`)
  },

  atualizaDocumentoStatusDeLote(id, data) {
    return axios.post(`${PREFIX}/${id}/alterar-status-lote`, data)
  },

  removerArquivosEmLoteDoServidor(arquivoEmLotesId) {
    return axios.post(`${PREFIX}/remove-arquivo-lote`, arquivoEmLotesId)
  },
}
